import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";
import { jsonToQuery } from "@/utils/queryHelper";

/**
 * Ferry Sales Service
 * Feribot satış API'leri için servis
 */
export const ferrySalesService = {
  /**
   * Sepet bilgilerini getir (Get Basket)
   * @param {Object} payload - İstek gövdesi
   * @param {number} payload.BasketId - Sepet ID'si
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {number} payload.AppVersion - Uygulama versiyonu
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Usage Example:
   * getBasket({
   *   BasketId: 123,
   *   LanguageCode: "tr",
   *   AppVersion: 0
   * })
   * → POST /v1/sferry/sales/getbasket
   */
  getBasket: (payload = {}, headers = {}, hasErrorHandler = false) => {
    return request({
      method: HTTP_METHODS.POST,
      url: API_URLS.ferry.sales.getBasket,
      payload,
      headers,
      hasErrorHandler,
    });
  },

  makePrebook: (payload = {}, headers = {}, hasErrorHandler = false) => {
    return request({
      method: HTTP_METHODS.POST,
      url: API_URLS.ferry.sales.makePrebook,
      payload,
      headers,
      hasErrorHandler,
    });
  },
  getCompanyImportantNotes: (
    query = {},
    headers = {},
    hasErrorHandler = false,
  ) => {
    return request({
      method: HTTP_METHODS.POST,
      url: API_URLS.ferry.sales.getCompanyImportantNotes,
      payload: query,
      headers,
      hasErrorHandler,
    });
  },
};
